export enum TabSize {
  Small = 'size-sm',
  Medium = 'size-md',
  Large = 'size-lg',
}
